// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2779":"c3046450","6794":"c3046450"}[chunkId] + ".chunk.css";
};